"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleConversionV3Stage = exports.GOOGLE_TAG_MANAGER_EVENT_NAME = void 0;
var GOOGLE_TAG_MANAGER_EVENT_NAME;
(function (GOOGLE_TAG_MANAGER_EVENT_NAME) {
    GOOGLE_TAG_MANAGER_EVENT_NAME["SUBMIT_STATED_INCOME"] = "submitStatedIncome";
    GOOGLE_TAG_MANAGER_EVENT_NAME["VIEW_PREQUAL"] = "viewPrequal";
    GOOGLE_TAG_MANAGER_EVENT_NAME["VIEW_AUTO_PREQUAL"] = "viewAutoPrequal";
    GOOGLE_TAG_MANAGER_EVENT_NAME["ACCEPT_PREQUAL_OFFER"] = "acceptPrequalOffer";
    GOOGLE_TAG_MANAGER_EVENT_NAME["VIEW_FINAL_OFFER"] = "viewFinalOffer";
    GOOGLE_TAG_MANAGER_EVENT_NAME["ACCEPT_FINAL_OFFER"] = "acceptFinalOffer";
    GOOGLE_TAG_MANAGER_EVENT_NAME["PRIMARY_CREDIT_CARD_CREATED"] = "primaryCreditCardCreated";
    GOOGLE_TAG_MANAGER_EVENT_NAME["SCHEDULED_NOTARIZATION"] = "scheduledNotarization";
    GOOGLE_TAG_MANAGER_EVENT_NAME["AVEN_CASH_PQ"] = "avenCashPQ";
    GOOGLE_TAG_MANAGER_EVENT_NAME["AVEN_CREDIT_CARD_PQ"] = "avenCreditCardPQ";
    GOOGLE_TAG_MANAGER_EVENT_NAME["VIEW_PREQUAL_COMPARE_HELOC_RATES"] = "viewPrequalCompareHelocRates";
    GOOGLE_TAG_MANAGER_EVENT_NAME["SUBMIT_AVEN_ADVISOR_HOMEOWNER_PHONE_NUMBER"] = "submitAvenAdvisorHomeownerPhoneNumber";
    GOOGLE_TAG_MANAGER_EVENT_NAME["BOOKED_CREDIT_CARD_LEAD"] = "bookedCreditCardLead";
    GOOGLE_TAG_MANAGER_EVENT_NAME["BOOKED_AVEN_CASH_LEAD"] = "bookedAvenCashLead";
    // v3 HELOC funnel events with updated LTV calcs, fired alongside the legacy events.
    GOOGLE_TAG_MANAGER_EVENT_NAME["LEAD_V3"] = "leadV3";
    GOOGLE_TAG_MANAGER_EVENT_NAME["PII_V3"] = "piiV3";
    GOOGLE_TAG_MANAGER_EVENT_NAME["VIEW_PREQUAL_V3"] = "viewPrequalV3";
    GOOGLE_TAG_MANAGER_EVENT_NAME["ACCEPT_PREQUAL_OFFER_V3"] = "acceptPrequalOfferV3";
    // UCC Pixel Events
    GOOGLE_TAG_MANAGER_EVENT_NAME["UCC_BOOKED"] = "uccBooked";
    // UCC Revolver
    GOOGLE_TAG_MANAGER_EVENT_NAME["UCC_PREQUAL_REVOLVER"] = "uccPrequalRevolver";
    GOOGLE_TAG_MANAGER_EVENT_NAME["UCC_BOOKED_REVOLVER"] = "uccBookedRevolver";
    // Crypto Pixel Events
    GOOGLE_TAG_MANAGER_EVENT_NAME["CRYPTO_CONFIRM_OFFER"] = "cryptoConfirmOffer";
    // Cashout Refi Pixel Events
    GOOGLE_TAG_MANAGER_EVENT_NAME["VIEW_CASHOUT_REFI_CONFIRMATION_PAGE"] = "viewCashoutRefiConfirmationPage";
})(GOOGLE_TAG_MANAGER_EVENT_NAME || (exports.GOOGLE_TAG_MANAGER_EVENT_NAME = GOOGLE_TAG_MANAGER_EVENT_NAME = {}));
// Funnel stage for the v3 HELOC conversions. Used by the backend value module
// (aven_backend/src/manager/googleConversionValueV3.ts) to key the per-stage value logic.
var GoogleConversionV3Stage;
(function (GoogleConversionV3Stage) {
    GoogleConversionV3Stage["lead"] = "lead";
    GoogleConversionV3Stage["pii"] = "pii";
    GoogleConversionV3Stage["pq"] = "pq";
    GoogleConversionV3Stage["pqa"] = "pqa";
    GoogleConversionV3Stage["booked"] = "booked";
})(GoogleConversionV3Stage || (exports.GoogleConversionV3Stage = GoogleConversionV3Stage = {}));
